<template>
  <li class="toast-item" :class="`toast-item--${toast.severity}`" role="alert">
    <IconSuccess class="toast-icon" v-if="toast.severity === 'success'" />
    <IconWarning class="toast-icon" v-if="toast.severity === 'error' || toast.severity === 'warning'" />

    <div class="toast-item--message">
      <span class="toast-item--title">{{ toast.title }}</span>
      <div class="toast-item--detail">{{ toast.detail }}</div>
    </div>

    <Button severity="tertiary" @click="removeToast">
      <template #iconLeft>
        <IconClose  />
      </template>
    </Button>
  </li>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import Button from './Button.vue';

import IconClose from '@/icons/toast/IconClose.svg?component';
import IconSuccess from '@/icons/toast/IconSuccess.svg?component';
import IconWarning from '@/icons/toast/IconWarning.svg?component';

import type { ToastNotification } from '@/types/Toast';

import { useToastStore } from '@/stores/toast';
const toastStore = useToastStore();

const props = defineProps<{
  toast: ToastNotification
}>()

onMounted(() => {
  setTimeout(() => {
    toastStore.remove(props.toast.id);
  }, props.toast.life);
});

const removeToast = () => {
  toastStore.remove(props.toast.id);
};
</script>

<style lang="scss">
.toast-item {
  @include mixins.flex-center($horiz: flex-start, $gap: 16px);
  background: #2b3a4b;
  border-radius: 6px;
  border: 1.5px solid transparent;
  max-width: 450px;
  min-width: 200px;
  padding: 12px 16px 12px 24px;
  width: fit-content;

  > svg {
    flex-shrink: 0;
  }

  .toast-icon {
    flex-basis: 20px;
  }

  .toast-item--message {
    color: variables.$primitives-color-background-100;
  }

  .toast-item--title {
    @include typography.font-body($size: 'md', $weight: 'bold');
  }

  &.toast-item--success {
    border-left: 8px solid variables.$primitives-color-secondary-400;
    color: variables.$primitives-color-secondary-400;

    .button--tertiary {
      color: variables.$primitives-color-secondary-400;
    }

    .button--tertiary:hover {
      color: variables.$primitives-color-background-100;
    }
  }

  &.toast-item--warning {
    border-left: 8px solid variables.$primitives-color-secondary-400;
    color: variables.$primitives-color-secondary-400;

    .button--tertiary {
      color: variables.$primitives-color-secondary-400;
    }

    .button--tertiary:hover {
      color: variables.$primitives-color-background-100;
    }
  }

  &.toast-item--error {
    border-left: 8px solid variables.$primitives-color-red-300;
    color: variables.$primitives-color-red-300;

    .button--tertiary {
      color: variables.$primitives-color-red-300;
    }

    .button--tertiary:hover {
      color: variables.$primitives-color-background-100;
    }
  }
}
</style>